module.exports = __webpack_public_path__ + "img/productCode.ce40fca5.png";